import { render, staticRenderFns } from "./SearchChecklistsItem.vue?vue&type=template&id=0c021c04&"
import script from "./SearchChecklistsItem.vue?vue&type=script&lang=js&"
export * from "./SearchChecklistsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports